import { getLocaleMessages } from './messages';
import type { AppLocale } from './types';

export function shellMessageId(zh: string) {
  return `shell.${zh}`;
}

export function translateShellText(
  locale: AppLocale,
  zh: string,
  en: string,
  params: Record<string, string | number> = {},
) {
  const text =
    locale === 'zh-CN' ? zh : (getLocaleMessages(locale)[shellMessageId(zh)] ?? en);
  return text.replace(/\{(\w+)\}/g, (placeholder, key: string) =>
    String(params[key] ?? placeholder),
  );
}
